$(function () {
	var selected_location = $('.service-location-selected');
	if (selected_location.val()) {
		assignLocation(selected_location.val(), selected_location.attr('data-name'), selected_location.attr('data-type'));
	}

	// ���� �� ������� ������ ��� � ����� �����������
	$('.service-box').on('click', '.location-popup', function () {
		var el = $(this);
		var type = el.attr('data-location-type');
		// ��������� ���������� ���� � ������ �������� ��������
		openLocationSelectionBox(type);
		return false;
	}).on('click', '.open-all', function () {
		openLocationSelectionBox('metro');
	});

	$('.service-location-additional-geos span').click(function () {
		clearLocation();
		var className = 'active-geo';
		$(this).parent().find('span').removeClass(className);
		$(this).addClass(className);

		var geoid = $(this).data('geoid');
		if (geoid) {
			assignLocation(geoid, $(this).text(), $(this).data('geotype'));
		} else {
			openLocationSelectionBox('metro');
		}
	});

	// var formatSq = wNumb({
	// 	decimals: 1,
	// 	thousand: ' ',
	// 	mark: ','
	// });

	if ($('#slider_square').length) {
		var slider_square = document.getElementById('slider_square');
		if (!$('input[name="flat[square]"]').val()) {
			$('input[name="flat[square]"]').val('55,0');
		}
		noUiSlider.create(slider_square,
			{
				start: $('input[name="flat[square]"]').val(),
				step: 0.5,
				range: {
					'min': 20,
					'70%': [100],
					'85%': [200, 5],
					'95%': 300,
					'max': 500
				},
				format: {
					to: function (value) {
						return parseInt(value);
					},
					from: function (value) {
						return parseInt(value);
					}
				}
			}
		);
		slider_square.noUiSlider.on('slide', function (values, handle) {
			$('input[name="flat[square]"]').val(values[handle]);
		});
		$('input[name="flat[square]"]').on('change', function () {
			slider_square.noUiSlider.set(this.value);
		});
	}

	if ($('.ocenka-results').length) {
		$('html,body').animate({
			scrollTop: $('.ocenka-results').offset().top
		}, 500);
	}

	$('.service-search-location-input').bind('keyup', function () {
		switchClearButton();
	});

	$('.service-search-location-clear').bind('click', function () {
		clearLocation();
		$('.service-search-location-input').focus();
	});

	switchClearButton();

	$('.service-search-location-input').autocomplete({
		lookup: function (query, done) {
			$.post(
				'/autocomplete/',
				{
					q: query,
					todo: 'ocenka'
				},
				function (data) {
					done({suggestions: data});
				},
				'json'
			);
		},
		onSelect: function (suggestion) {
			assignLocation(suggestion.data.id, suggestion.value, suggestion.data.calc_geo_type);
		},
		formatResult: function (suggestion, currentValue) {
			return '<a href="#" onclick="return false">' + suggestion.value + '</a>';
		},
		maxHeight: 'auto'
	});

	processHouseType();
	$('#house-type-selector').on('change', processHouseType);
});

function processHouseType() {
	var value = $('#house-type-selector').val();
	if (value == 6) {
		$('#first-floor-box').addClass('hidden');
		$('.flat_do_mkad').hide();
	} else {
		$('#first-floor-box').removeClass('hidden');
		$('.flat_do_mkad').show();
	}
}

function switchClearButton() {
	if (!$('.service-search-location-input').val()) {
		$('.service-search-location-clear').addClass('hidden');
	} else {
		$('.service-search-location-clear').removeClass('hidden');
	}
}

function openLocationSelectionBox(type) {

	var prefix = 'price';
	var boxWidth = $(window).width() - 32;
	if (boxWidth > 900) {
		boxWidth = 900;
	}
	var pBox = new popupBox({
		width: boxWidth,
		top: ($(window).scrollTop() + 50),
		prefix: prefix,
		callBack: function () {
		}
	});

	var svgMetroSelector = '#metro-svg';
	var isDrag = false;
	var showMO = $(".service-location[data-type='city']").length > 0 ? 1 : 0;

	pBox.openBox();

	$.post(
		'/s_ajax_location.php',
		{type: type, prefix: prefix, podmoskovie: showMO, okrug: false},
		function (data) {
			pBox.fillBox(data);
			setPopupTabSelection(type);

			$("#service-popup-selectors .service-popup-selectors-tab").click(function () {
				setPopupTabSelection($(this).attr('data-location-type'));
				return false;
			});

			var isMetroDragging = false;

			$('#service-popup-containers').on('click', '.service-list-link,.station', function (e) {
				if ($(e.target).data('drag') === true || isDrag) {
					return false;
				}
				var name = $(this).attr('title') ? $(this).attr('title') : $(this).text();
				var id = $(this).data('id') ? $(this).data('id') : $(this).attr('rel');
				assignLocation(id, name, getPopupType());
				pBox.closePopup();
				return pauseEvent(e);
			}).on('submit', 'form', function () {
				return false;
			})
				.on('click', '.service-search-clear', function () {
					var el = $(this).parent().find('.input-search');
					el.val('');
					return searchItems(el);
				}).on('input', '.input-search', function () {
				return searchItems($(this));
			}).on('change', '#service-popup-tab-metro input', function () {
				switchMetroTab($(this).val());
			});
			$("#head").css({opacity: 0});

			var dragTempCoords = [];

			var getCoords = function (e) {
				if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
					return [e.touches[0].clientX, e.touches[0].clientY];
				} else if (e.type === 'mousedown' || e.type === 'mouseup' || e.type === 'mousemove' || e.type === 'mouseover' || e.type === 'mouseout' || e.type === 'mouseenter' || e.type === 'mouseleave') {
					return [e.clientX, e.clientY];
				}

				return [undefined, undefined];
			}

			var metroContainer = $('.metromapdiv');
			var svg = $(svgMetroSelector);

			var left = (svg.width() - metroContainer.innerWidth()) / 2;
			var top = (svg.height() - metroContainer.innerHeight()) / 2;
			svg.css({left: -left, top: -top});

			var onTouchStart = function (e) {
				var coords = getCoords(e);
				dragTempCoords[0] = coords[0];
				dragTempCoords[1] = coords[1];
				dragTempCoords[2] = parseInt($(svgMetroSelector).css('left'));
				dragTempCoords[3] = parseInt($(svgMetroSelector).css('top'));
				isMetroDragging = true;

				return pauseEvent(e);
			};

			var onTouchMove = function (e) {
				if (isMetroDragging) {

					var coords = getCoords(e);
					var newX = coords[0];
					var newY = coords[1];

					var diffX = newX - dragTempCoords[0];
					var diffY = newY - dragTempCoords[1];

					isDrag = true;
					if (!$(e.target).data('drag') && (diffX > 1 || diffY > 1)) {
						$(e.target).data('drag', true);
					}

					var newLeft = dragTempCoords[2] + diffX;
					var newTop = dragTempCoords[3] + diffY;

					var contWidth = metroContainer.innerWidth();
					var contHeight = metroContainer.innerHeight();
					var svgWidth = svg.width();
					var svgHeight = svg.height();

					var minLeft = contWidth - svgWidth;
					if (newLeft < minLeft) {
						newLeft = minLeft;
					}

					var maxLeft = contWidth > svgWidth ? (contWidth - svgWidth) / 2 : 0;
					var maxTop = contHeight > svgHeight ? (contHeight - svgHeight) / 2 : 0;

					if (newLeft > maxLeft) {
						newLeft = maxLeft;
					}

					var minTop = contHeight - svgHeight;
					if (newTop < minTop) {
						newTop = minTop;
					}

					if (newTop > maxTop) {
						newTop = maxTop;
					}

					svg.css({
						left: newLeft + 'px',
						top: newTop + 'px'
					});
				}

				return pauseEvent(e);
			};

			var onTouchEnd = function (e) {
				isMetroDragging = false;

				setTimeout(function () {
					isDrag = false;
					$(e.target).data('drag', false);
				}, 300);

				return pauseEvent(e);
			};

			$('body')
				.on('mousedown', svgMetroSelector, onTouchStart)
				.on('mousemove', svgMetroSelector, onTouchMove)
				.on('mouseup', svgMetroSelector, onTouchEnd)
				.on('touchstart', svgMetroSelector, onTouchStart)
				.on('touchmove', svgMetroSelector, onTouchMove)
				.on('touchend', svgMetroSelector, onTouchEnd);

			metroContainer.on('wheel', function (event) {

				var e = event.originalEvent;

				var width = parseInt(svg.attr('width'));
				var height = parseInt(svg.attr('height'));

				var left = parseInt(svg.css('left'));
				var top = parseInt(svg.css('top'));

				var contWidth = metroContainer.innerWidth();
				var contHeight = metroContainer.innerHeight();

				var containerOffset = metroContainer.offset();
				var x = e.pageX - containerOffset.left;
				var y = e.pageY - containerOffset.top;

				var Ax = (-left + x) / width;
				var Ay = (-top + y) / height;

				var minWidth = contWidth;
				var maxWidth = 2000;
				var minHeight = contHeight;
				var maxHeight = 2000;

				var minLeft = contWidth >= width ? (contWidth - width) / 2 : 0;
				var minTop = contHeight >= height ? (contHeight - height) / 2 : 0;

				var delta = e.deltaY || e.detail || e.wheelDelta;

				if (delta < 0) {
					if (width < maxWidth) {
						width += 100;
						if (width > maxWidth) {
							width = maxWidth;
						}
					}
					if (height < maxHeight) {
						height += 100;
						if (height > maxHeight) {
							height = maxHeight;
						}
					}
				} else {
					if (width > minWidth) {
						width -= 100;
						if (width < minWidth) {
							width = minWidth;
						}
					}
					if (height > minHeight) {
						height -= 100;
						if (height < minHeight) {
							height = minHeight;
						}
					}
				}

				left = Ax * width - x;
				top = Ay * height - y;

				if (top < minTop) {
					top = minTop;
				}

				if (left < minLeft) {
					left = minLeft;
				}

				svg.attr('width', width);
				svg.attr('height', height);
				svg.css('left', -left);
				svg.css('top', -top);

				return false;
			});
		}
	);

	return false;
}

function pauseEvent(e) {
	e.stopPropagation();
	e.preventDefault();
	e.cancelBubble = true;
	e.returnValue = false;
	return false;
}

function assignLocation(id, name, type) {
	$('.service-location').val('');
	$(".service-location[data-type='" + type + "']").val(id);
	$('.service-location-selectors').addClass('hidden');
	$('.service-location-selected').val(id).attr('data-type', type).attr('data-name', name);
	$('.service-search-location-input').val(name);
	var openAllTag = $('.open-all');

	var location_tag = getLocationTag(id, name);
	location_tag.click(function () {
		clearLocation();
		$('.service-search-location-input').val(name).focus();
	});
	$('.service-location-selected-geo').html(location_tag).removeClass('hidden');

	if (!$('.service-location-additional-geos').length) {
		openAllTag.removeClass('hidden');
		$('.service-location-selected-geo').append(openAllTag);
	}

	toggleDistance(id, type);
	switchClearButton();
}

function toggleDistance(id, type) {
	id = parseInt(id);
	if (type === 'metro' || type === 'district') {
		if (district_no_metro[id]) {
			$('.flat_do_metro').addClass('hidden');
		} else {
			$('.flat_do_metro').removeClass('hidden');
		}
		$('.flat_do_mkad').addClass('hidden');
	}
	if (type === 'city') {
		if (city_with_metro[id]) {
			$('.flat_do_mkad').addClass('hidden');
			$('.flat_do_metro').removeClass('hidden');
		} else {
			if (city_near_mkad[id]) {
				$('.flat_do_mkad').removeClass('hidden');
				$('.flat_do_metro').addClass('hidden');
			} else {
				$('.flat_do_mkad').addClass('hidden');
				$('.flat_do_metro').addClass('hidden');
			}
		}
	}
}

function clearLocation() {
	$('.service-location').val('');
	$('.service-location-selectors').removeClass('hidden');
	$('.service-location-selected-geo').addClass('hidden');
	$('.service-search-location-input').val('');
	$('.flat_do_mkad').addClass('hidden');
	$('.flat_do_metro').addClass('hidden');
	$('.service-location-additional-geos span').removeClass('active-geo');
	switchClearButton();
}
